export default __webpack_public_path__ + "static/media/helpful-reaction-yellow.ccb2e123.svg";